/*
 * A channel's short name is what its address is made of (`/c/<slug>`), so it is offered rather than
 * demanded: the dialog derives it from the name as it is typed and stops as soon as somebody edits
 * it by hand. The rule is the server's (`error.chat.slugInvalid`): lower-case letters, digits and
 * dashes.
 *
 * The derivation is deliberately lossy and never creative. A name that leaves nothing behind — one
 * written entirely in a script this rule cannot spell — produces an empty slug, and the dialog then
 * asks for one instead of inventing something the person did not choose.
 */

/**
 * The url segment law of spec 05 §5, as `slugPattern` in internal/modules/chat/model.go: a
 * lower-case letter or digit, then between one and thirty-one more of those or a dash. The dialog
 * cuts and checks here so the refusal is a hint under the field rather than a round trip.
 */
export const SLUG_MAX = 32

export function slugify(name: string): string {
	return (
		name
			.toLowerCase()
			// Accents are dropped rather than transliterated: "Ubungen" from "Übungen" is a name a
			// person recognises, "u308bungen" is not.
			.normalize("NFD")
			.replace(/\p{Diacritic}/gu, "")
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/^-+|-+$/g, "")
			.slice(0, SLUG_MAX)
			.replace(/-+$/, "")
	)
}

/** True while a slug is one the server's own pattern accepts. */
export function isValidSlug(slug: string): boolean {
	return /^[a-z0-9][a-z0-9-]{1,31}$/.test(slug)
}
